import template from './form.html';
import { FormActions } from 'core/services/form';
import solicitudesPermisosI18N from 'i18n/solicitudes-permisos/es.json';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import config from 'config.json';
import { NotificationDropdownActions } from 'core/services/notifications';
import { formatErrorMessage } from 'core/util';

export let SolicitudPermisoFormComponent = {
  templateUrl: template,
  selector: 'solicitudPermisoForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(solicitudesPermisosI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$websocket'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, $websocket) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.loadEmpleados = loadEmpleados.bind(this);
  this.renderEmpleado = renderEmpleado.bind(this);
  this.loadUsuarios = loadUsuarios.bind(this);
  this.renderUsuario = renderUsuario.bind(this);
  this.checkDestinatario = checkDestinatario.bind(this);
  this.aprobar = aprobar.bind(this);
  this.rechazar = rechazar.bind(this);
  this.markAsRead = markAsRead.bind(this);
  this.onChangeDate = onChangeDate.bind(this);
  let unsubscribe;

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    const actions = Object.assign({}, FormActions, NotificationDropdownActions);
    unsubscribe = $ngRedux.connect(this.mapStateToThis, actions)(this);

    if ($stateParams.uid) {
      const filter = Filter.path('tipo.codigo').eq('estado_solicitud_permiso');
      this.title = this.view ? this.translations['Ver solicitud de permiso'] : this.translations['Editar solicitud de permiso'];
      this.formEdit('solicitudes-permisos', $stateParams.uid);
      $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(filter) }));

      if ($stateParams.notify) {
        this.markAsRead();
      }
    } else {
      this.title = this.translations['Nueva solicitud de permiso'];
      this.form();
    }
    this.redirectAfterSave = true;
  };

  this.localModel = {
    hastaOptions: {},
    desdeOptions: {}
  };

  function onChangeDate() {
    if (this.model) {
      this.localModel.desdeOptions.maxDate = this.model.hasta;
      this.localModel.hastaOptions.minDate = this.model.desde;
    }
  }

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    let model = state.form.model;
    let estadoAprobado = state.valores.data.filter(v => v.value === 'Aprobado');
    let estadoRechazado = state.valores.data.filter(v => v.value === 'Rechazado');

    if (model.id) {
      // model.fechaSolicitud = moment(model.fechaSolicitud, 'DD/MM/YYYY').toDate();
      // model.desde = moment(model.desde, 'DD/MM/YYYY').toDate();
      // model.hasta = moment(model.hasta, 'DD/MM/YYYY').toDate();

      if (model.estado.value === 'Ingresado') {
        this.isIngresado = true;
      } else if (model.estado.value === 'Rechazado') {
        this.isRechazado = true;
      } else if (model.estado.value === 'Aprobado') {
        this.isAprobado = true;
      }
      this.checkDestinatario(model, state.currentUser.data);
      this.onChangeDate();
    }

    return {
      form: state.form,
      model,
      estadoAprobado: estadoAprobado && estadoAprobado.length ? estadoAprobado[0] : {},
      estadoRechazado: estadoRechazado && estadoRechazado.length ? estadoRechazado[0] : {}
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.solicitudes-permisos.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');

      if (this.redirectAfterSave) {
        $state.go('home.solicitudes-permisos.list');
      } else {
        $state.reload();
      }
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);
    // data.fechaSolicitud = moment(data.fechaSolicitud).format('DD/MM/YYYY');
    // data.desde = moment(data.desde).format('DD/MM/YYYY');
    // data.hasta = moment(data.hasta).format('DD/MM/YYYY');

    let desde;
    let hasta;
    if (typeof data.desde.getMonth === 'function') {
      desde = data.desde;
    } else {
      desde = moment(data.desde, 'DD/MM/YYYY').toDate();
    }
    if (typeof data.hasta.getMonth === 'function') {
      hasta = data.hasta;
    } else {
      hasta = moment(data.hasta, 'DD/MM/YYYY').toDate();
    }

    if (desde > hasta) {
      ngNotify.set(this.translations['Rango fecha desde hasta invalido'], 'warn');
      return;
    }


    this.save('solicitudes-permisos', data);
  }

  /**
   * Se encarga de traer el backend la lista de empleados a mostrar.
   * 
   * @param {string} query 
   */
  function loadEmpleados(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('estadoCivil.value').like(query))
        .or(Filter.path('telefono').like(query)));
    }
    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderEmpleado(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }


  /**
   * Se encarga de traer el backend la lista de usuarios a mostrar.
   * 
   * @param {string} query 
   */
  function loadUsuarios(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('username').like(query))
        .or(Filter.path('email').like(query))
        .or(Filter.path('activo').eq(true)));
    }
    BasicFactory.setup('usuarios');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderUsuario(usuario) {
    return `${usuario.nombre} ${usuario.apellido}`;
  }

  /**
   * Se encarga de verificar si el usuario actual del sistema es uno de los destinatarios de la solicitud.
   * 
   * @param {Object} model - la solicitud en cuestión 
   * @param {Object} user  - el usuario actual del sistema.
   */
  function checkDestinatario(model, user) {
    const destinatarios = model.destinatarios;

    if (!destinatarios) {
      this.isDestinatario = false;
      return;
    }
    this.isDestinatario = _.find(destinatarios, { id: user.id }) !== undefined;
  }

  function aprobar() {
    this.model.estado = this.estadoAprobado;
    this.redirectAfterSave = false;
    this.doSubmit();
  }

  function rechazar() {
    this.model.estado = this.estadoRechazado;
    this.redirectAfterSave = false;
    this.doSubmit();
  }


  /**
   * Manda vía websocket un mensaje que le indica al backend que
   * debe marcar la notificación como leída. 
   */
  function markAsRead() {
    const stream = $websocket(`${config.websocketURL}/notifications`);
    stream.onMessage(message => {
      let pm = JSON.parse(message.data);

      if (pm.action === 'mark-read' && pm.payload === 'done') {
        stream.close();
        this.markNotificationAsRead(location.href);
      }
    });
    // Obtener id de la notificacion de la url y agregarla al filtro para enviar al backend
    let id = parseInt(location.href.split('/')[5]);
    let filter = Filter.path('id').eq(id);
    stream.send({ action: 'mark-read', payload: JSON.stringify(filter) });
  }
}


// WEBPACK FOOTER //
// ./src/components/solicitudes-permisos/form/form.component.js